/**
 * Reading a barcode off a picture — the nutrition spec, Logging an entry. The browser's own
 * reader where it has one, and one lent to it where it has not: the ponyfill is the same
 * interface over a decoder shipped with the app, loaded only when it is needed, so a code is
 * read wherever the camera opens.
 */

/** The codes a packet carries: the retail ones, and the one a home label tends to be. */
const FORMATS = ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128']

export interface CodeReader {
  detect(source: ImageBitmapSource): Promise<readonly { rawValue: string }[]>
}

type ReaderMaker = new (options?: { formats?: string[] }) => CodeReader

export async function codeReader(): Promise<CodeReader> {
  const own = (globalThis as { BarcodeDetector?: ReaderMaker }).BarcodeDetector
  if (own !== undefined) {
    return new own({ formats: FORMATS })
  }
  const { BarcodeDetector } = await import('barcode-detector/ponyfill')
  return new BarcodeDetector({ formats: FORMATS as never[] })
}
